import { combineReducers } from 'redux';
import { filterActions } from 'redux-ignore';
import { APP_RESET } from '../constants/app';
import { PAGE_HOME } from '../constants/pages';
import app from './app/app';
import auth from './auth/auth';
import notifications from './notifications/notifications';
import unity from './unity/unity';
import preferences from './preferences/preferences';
import research from './research/research';
import grades from './grades/grades';
import engineering from './engineering/engineering';
import simulation from './simulation/simulation';
import outputs from './outputs/outputs';
import filemanager from './filemanager/filemanager';
import journal from './journal/journal';
import game from './game/game';
import announcements from './announcements/announcements';

function filterByPrefix(prefix) {
  return (action) => action.type && action.type.startsWith(prefix);
}

/*
 * A note about the reducer composition below: For select sub-reducers, we are
 * using redux-ignore to skip reducer calls when the action does not match.  Some
 * reducers are affected by actions that typically deal with their similarly named
 * reducer, such as the `research` reducer listening for APP_SET_PAGE.  These reducers
 * cannot be filtered so easily as string prefix, and keep that in mind when adding
 * action listeners to any reducers that are filtered.
 */
const appReducer = combineReducers({
  app,
  auth: filterActions(auth, filterByPrefix('AUTH_')),
  notifications,
  unity,
  preferences,
  research,
  grades: filterActions(grades, filterByPrefix('GRADE_')),
  engineering: filterActions(
    engineering,
    (action) =>
      filterByPrefix('ENG_') || action.type === 'SIMULATION_START_SUCCESS'
  ),
  simulation: filterActions(simulation, filterByPrefix('SIMULATION_')),
  outputs,
  filemanager,
  journal: filterActions(journal, filterByPrefix('JOURNAL_')),
  game,
  announcements: filterActions(announcements, filterByPrefix('ANNOUNCE_')),
});

const root = (state, action) => {
  if (action.type === APP_RESET) {
    // resetting the app should not reset the appList or loading state
    const appList = state.app.appList;
    const loading = state.app.loading;

    state = {
      app: {
        ...app(undefined, {}),
        appList,
        loading,
        page: PAGE_HOME,
      },
      // optionally reset the auth reducer
      auth: auth(action.logout === true ? undefined : state.auth, {}),
    };
  }

  return appReducer(state, action);
};

export default root;
